export const sdkDebuggerRecordingId = "/sdk/debugger/:recording_id/session";
